/* ============================================================
 * RoyalChicByPriti — Conversion mechanics layer
 * Injects: announcement marquee (seamless), PDP trust block,
 *          WhatsApp inquiry button, sticky mobile cart,
 *          recently viewed, cart drawer free-shipping badge,
 *          floating WhatsApp FAB, newsletter popup.
 * ============================================================ */
(function () {
  'use strict';

  var WHATSAPP_NUMBER = '919810992373';
  var RECENTLY_VIEWED_KEY = 'rc_recently_viewed_v1';
  var RECENTLY_VIEWED_MAX = 8;
  var MARQUEE_COPIES = 4;
  var NEWSLETTER_KEY = 'rc_newsletter_status_v1';
  var NEWSLETTER_EMAILS_KEY = 'rc_newsletter_emails_v1';
  var NEWSLETTER_DELAY_MS = 18000;
  var NEWSLETTER_REPROMPT_DAYS = 30;

  function isProductPage() {
    return document.body.classList.contains('template-product') ||
           document.querySelector('main .product') !== null ||
           window.location.pathname.indexOf('/products/') === 0;
  }

  function readProductMeta() {
    var ogTitle = document.querySelector('meta[property="og:title"]');
    var ogUrl = document.querySelector('meta[property="og:url"]') || document.querySelector('link[rel="canonical"]');
    var ogImage = document.querySelector('meta[property="og:image"]');
    var priceEl = document.querySelector('.price-item--regular, .price-item--sale, .price__regular .price-item');
    return {
      title: ogTitle ? ogTitle.getAttribute('content') : document.title,
      url: ogUrl ? ogUrl.getAttribute('content') || ogUrl.getAttribute('href') : window.location.href,
      image: ogImage ? ogImage.getAttribute('content') : null,
      price: priceEl ? priceEl.textContent.trim() : ''
    };
  }

  // ---------- Seamless announcement marquee ----------
  function setupAnnouncementMarquee() {
    var msg = document.querySelector('.announcement-bar__message') ||
              document.querySelector('.announcement-bar__announcement');
    if (!msg) return;
    if (msg.dataset.rcMarqueeReady === '1') return;

    var text = '';
    var nodes = msg.childNodes;
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (node.nodeType === 3) {
        text += node.textContent;
      } else if (node.nodeType === 1) {
        var tag = node.tagName ? node.tagName.toLowerCase() : '';
        var cls = node.className && typeof node.className === 'string' ? node.className : '';
        if (tag !== 'svg' && cls.indexOf('svg-wrapper') === -1 && cls.indexOf('icon-wrap') === -1) {
          text += node.textContent;
        }
      }
    }
    text = text.trim();
    if (!text) return;

    msg.innerHTML = '';
    msg.classList.add('rc-marquee-host');

    var track = document.createElement('span');
    track.className = 'rc-marquee-track';
    for (var j = 0; j < MARQUEE_COPIES; j++) {
      var item = document.createElement('span');
      item.className = 'rc-marquee-item';
      item.textContent = text;
      track.appendChild(item);
    }
    msg.appendChild(track);
    msg.dataset.rcMarqueeReady = '1';
  }

  // ---------- PDP Trust Block ----------
  function buildPdpTrustBlock(product) {
    var wrapper = document.createElement('div');
    wrapper.className = 'rc-pdp-trust';
    wrapper.innerHTML = [
      '<ul class="rc-pdp-trust__list">',
      '  <li class="rc-pdp-trust__item">',
      '    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18h5a1 1 0 0 0 1-1v-3.34a2 2 0 0 0-.59-1.41l-2.66-2.66A2 2 0 0 0 16.34 9H14"/><circle cx="7.5" cy="18.5" r="2.5"/><circle cx="17.5" cy="18.5" r="2.5"/></svg>',
      '    <div><strong>Free Pan-India Shipping</strong><span>Ships in 24 hrs &middot; 4-7 days delivery</span></div>',
      '  </li>',
      '  <li class="rc-pdp-trust__item">',
      '    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s-8-4.5-8-11.5A5.5 5.5 0 0 1 12 6a5.5 5.5 0 0 1 8 4.5C20 17.5 12 22 12 22z"/></svg>',
      '    <div><strong>Authentic from Chandni Chowk</strong><span>Direct from wholesale market</span></div>',
      '  </li>',
      '  <li class="rc-pdp-trust__item">',
      '    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>',
      '    <div><strong>International Delivery</strong><span>US, UK, UAE, SG, AU &middot; 10-21 days</span></div>',
      '  </li>',
      '  <li class="rc-pdp-trust__item">',
      '    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>',
      '    <div><strong>WhatsApp Support</strong><span>+91 98109 92373 &middot; quick replies</span></div>',
      '  </li>',
      '</ul>',
      '<div class="rc-pdp-trust__actions">',
      '  <a class="rc-pdp-trust__link" href="/blogs/style-guide/how-to-measure-unstitched-suit-size-guide" target="_blank" rel="noopener">',
      '    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M21 6H3"/><path d="M21 12H3"/><path d="M21 18H3"/></svg>',
      '    Size guide — how to measure',
      '  </a>',
      '  <a class="rc-pdp-trust__link" href="/blogs/style-guide/care-of-unstitched-fabrics" target="_blank" rel="noopener">',
      '    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9 12l2 2 4-4"/></svg>',
      '    Fabric care &amp; washing guide',
      '  </a>',
      '</div>',
      '<div class="rc-pdp-trust__care">',
      '  <span class="rc-pdp-trust__care-item" title="Gentle wash">',
      '    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12c0 5-3.5 8-9 8s-9-3-9-8 4-9 9-9 9 4 9 9z"/><path d="M8 14a3 3 0 0 0 6 0"/></svg>',
      '    Gentle Wash',
      '  </span>',
      '  <span class="rc-pdp-trust__care-item" title="Cool iron">',
      '    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M6 6h12l3 6v6H3v-6z"/><circle cx="9" cy="14" r=".7"/><circle cx="15" cy="14" r=".7"/></svg>',
      '    Cool Iron',
      '  </span>',
      '  <span class="rc-pdp-trust__care-item" title="Dry clean recommended">',
      '    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M8 12h8"/></svg>',
      '    Dry Clean OK',
      '  </span>',
      '  <span class="rc-pdp-trust__care-item" title="No bleach">',
      '    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M3 21l18-18"/><path d="M5 3l14 14"/></svg>',
      '    No Bleach',
      '  </span>',
      '</div>'
    ].join('');
    return wrapper;
  }

  function buildWhatsAppButton(product) {
    var message = encodeURIComponent('Hi RoyalChicByPriti! I am interested in: ' + product.title + '\n\nLink: ' + product.url + '\n\nCould you help me with details?');
    var url = 'https://wa.me/' + WHATSAPP_NUMBER + '?text=' + message;
    var btn = document.createElement('a');
    btn.className = 'rc-whatsapp-btn';
    btn.href = url;
    btn.target = '_blank';
    btn.rel = 'noopener';
    btn.setAttribute('aria-label', 'Inquire about this product on WhatsApp');
    btn.innerHTML = [
      '<svg width="22" height="22" viewBox="0 0 24 24" fill="#fff"><path d="M17.5 14.4c-.3-.1-1.8-.9-2-1s-.5-.1-.7.1-.8 1-1 1.2-.4.2-.7.1-1.3-.5-2.5-1.5c-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6s.3-.3.4-.5c.1-.2.2-.3.2-.5s-.1-.4-.2-.5c-.1-.1-.7-1.7-1-2.3-.3-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.7.4-.3.3-1 1-1 2.4s1 2.8 1.2 3 2 3 4.8 4.2c.7.3 1.2.5 1.6.6.7.2 1.3.2 1.8.1.5-.1 1.7-.7 2-1.4.2-.7.2-1.3.2-1.4-.1-.1-.3-.2-.5-.3z"/><path d="M12 2C6.5 2 2 6.5 2 12c0 1.8.5 3.5 1.4 5L2 22l5.2-1.4c1.4.8 3 1.2 4.8 1.2 5.5 0 10-4.5 10-10S17.5 2 12 2zm0 18.2c-1.6 0-3.1-.4-4.4-1.2l-.3-.2-3.2.9.9-3.1-.2-.3c-.9-1.4-1.3-3-1.3-4.6 0-4.5 3.7-8.2 8.2-8.2s8.2 3.7 8.2 8.2-3.7 8.2-8.2 8.2z"/></svg>',
      '<span>Inquire about this product</span>'
    ].join('');
    return btn;
  }

  function buildStickyMobileBar(product) {
    var bar = document.createElement('div');
    bar.className = 'rc-sticky-cart';
    bar.innerHTML = [
      '<div class="rc-sticky-cart__info">',
      '  <span class="rc-sticky-cart__title">' + (product.title || '').replace(/[<>]/g, '') + '</span>',
      '  <span class="rc-sticky-cart__price">' + (product.price || '') + '</span>',
      '</div>',
      '<button type="button" class="rc-sticky-cart__btn">Add to cart</button>'
    ].join('');
    bar.querySelector('.rc-sticky-cart__btn').addEventListener('click', function () {
      var realBtn = document.querySelector('product-form button[type="submit"]') ||
                    document.querySelector('form[action*="/cart/add"] button[type="submit"]') ||
                    document.querySelector('button[name="add"]');
      if (realBtn) {
        realBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { realBtn.click(); }, 400);
      }
    });
    return bar;
  }

  // ---------- Recently viewed ----------
  function getRecentlyViewed() {
    try { var raw = localStorage.getItem(RECENTLY_VIEWED_KEY); return raw ? JSON.parse(raw) : []; } catch (e) { return []; }
  }

  function saveRecentlyViewed(item) {
    try {
      var list = getRecentlyViewed();
      list = list.filter(function (p) { return p.url !== item.url; });
      list.unshift(item);
      list = list.slice(0, RECENTLY_VIEWED_MAX);
      localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function renderRecentlyViewed() {
    var list = getRecentlyViewed();
    var currentUrl = window.location.pathname;
    list = list.filter(function (p) { return p.url.indexOf(currentUrl) === -1; });
    if (list.length < 2) return null;
    var section = document.createElement('section');
    section.className = 'rc-recently-viewed';
    var html = ['<div class="page-width"><h2 class="rc-recently-viewed__heading h3">Recently viewed</h2><div class="rc-recently-viewed__grid">'];
    list.slice(0, 6).forEach(function (p) {
      html.push(
        '<a class="rc-recently-viewed__card" href="' + p.url + '">' +
          (p.image ? '<img src="' + p.image + '" alt="' + (p.title || '').replace(/"/g, '') + '" loading="lazy">' : '') +
          '<span class="rc-recently-viewed__title">' + (p.title || '').replace(/[<>]/g, '') + '</span>' +
          (p.price ? '<span class="rc-recently-viewed__price">' + p.price + '</span>' : '') +
        '</a>'
      );
    });
    html.push('</div></div>');
    section.innerHTML = html.join('');
    return section;
  }

  // ---------- Cart drawer shipping badge ----------
  function injectCartShippingBadge() {
    /* top shipping badge merged per user request */
    return;
  }

  // ---------- Floating WhatsApp FAB ----------
  function setupFloatingWhatsApp() {
    if (document.querySelector('.rc-fab-whatsapp')) return;
    var msg = encodeURIComponent('Hi RoyalChicByPriti! I have a question.');
    var fab = document.createElement('a');
    fab.className = 'rc-fab-whatsapp';
    fab.href = 'https://wa.me/' + WHATSAPP_NUMBER + '?text=' + msg;
    fab.target = '_blank';
    fab.rel = 'noopener';
    fab.setAttribute('aria-label', 'Chat with us on WhatsApp');
    fab.innerHTML = [
      '<svg width="32" height="32" viewBox="0 0 448 512" fill="#fff">',
      '<path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"/>',
      '</svg>'
    ].join('');
    document.body.appendChild(fab);
  }

  // ---------- Newsletter Popup ----------
  function getNewsletterStatus() {
    try { return JSON.parse(localStorage.getItem(NEWSLETTER_KEY) || 'null'); } catch (e) { return null; }
  }

  function setNewsletterStatus(status) {
    try {
      localStorage.setItem(NEWSLETTER_KEY, JSON.stringify({ status: status, ts: Date.now() }));
    } catch (e) {}
  }

  function shouldShowNewsletter() {
    var s = getNewsletterStatus();
    if (!s) return true;
    if (s.status === 'subscribed') return false;
    if (s.status === 'dismissed') {
      var daysSince = (Date.now() - (s.ts || 0)) / 86400000;
      return daysSince > NEWSLETTER_REPROMPT_DAYS;
    }
    return true;
  }

  function saveNewsletterEmail(email) {
    try {
      var list = JSON.parse(localStorage.getItem(NEWSLETTER_EMAILS_KEY) || '[]');
      list.push({ email: email, ts: Date.now() });
      localStorage.setItem(NEWSLETTER_EMAILS_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function showNewsletterPopup() {
    if (document.getElementById('rcNewsletterPopup')) return;
    var popup = document.createElement('div');
    popup.className = 'rc-newsletter-popup';
    popup.id = 'rcNewsletterPopup';
    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-modal', 'true');
    popup.innerHTML = [
      '<div class="rc-newsletter-popup__overlay"></div>',
      '<div class="rc-newsletter-popup__card">',
      '  <button type="button" class="rc-newsletter-popup__close" aria-label="Close">&times;</button>',
      '  <div class="rc-newsletter-popup__form-state">',
      '    <span class="rc-newsletter-popup__badge">Limited offer</span>',
      '    <h3 class="rc-newsletter-popup__heading">Get 5% off your first order</h3>',
      '    <p class="rc-newsletter-popup__sub">Subscribe for exclusive offers and style inspiration from Chandni Chowk.</p>',
      '    <form class="rc-newsletter-popup__form">',
      '      <input type="email" required placeholder="your@email.com" aria-label="Email address">',
      '      <button type="submit">Get my code</button>',
      '    </form>',
      '    <p class="rc-newsletter-popup__legal">No spam. Unsubscribe anytime.</p>',
      '  </div>',
      '  <div class="rc-newsletter-popup__success-state" hidden>',
      '    <div class="rc-newsletter-popup__success-icon">✓</div>',
      '    <h3 class="rc-newsletter-popup__heading">Thank you!</h3>',
      '    <p class="rc-newsletter-popup__sub">Use this code at checkout for 5% off:</p>',
      '    <div class="rc-newsletter-popup__code">WELCOME5</div>',
      '    <button type="button" class="rc-newsletter-popup__dismiss">Continue shopping</button>',
      '  </div>',
      '</div>'
    ].join('');
    document.body.appendChild(popup);

    function close() {
      popup.classList.add('rc-newsletter-popup--closing');
      setTimeout(function () { if (popup.parentNode) popup.parentNode.removeChild(popup); }, 250);
      setNewsletterStatus('dismissed');
    }
    popup.querySelector('.rc-newsletter-popup__close').addEventListener('click', close);
    popup.querySelector('.rc-newsletter-popup__overlay').addEventListener('click', close);
    popup.querySelector('.rc-newsletter-popup__dismiss').addEventListener('click', close);

    popup.querySelector('.rc-newsletter-popup__form').addEventListener('submit', function (e) {
      e.preventDefault();
      var email = e.target.querySelector('input[type="email"]').value;
      saveNewsletterEmail(email);
      setNewsletterStatus('subscribed');
      popup.querySelector('.rc-newsletter-popup__form-state').setAttribute('hidden', '');
      popup.querySelector('.rc-newsletter-popup__success-state').removeAttribute('hidden');
    });

    // Trigger CSS open animation
    requestAnimationFrame(function () { popup.classList.add('rc-newsletter-popup--open'); });
  }

  function setupNewsletterPopup() {
    if (!shouldShowNewsletter()) return;
    setTimeout(showNewsletterPopup, NEWSLETTER_DELAY_MS);
  }

  // ---------- Mount logic ----------
  function mountProductEnhancements() {
    if (!isProductPage()) return;
    var product = readProductMeta();
    if (product.title && product.url) saveRecentlyViewed(product);
    var anchor = document.querySelector('product-form') || document.querySelector('.product-form') || document.querySelector('form[action*="/cart/add"]');
    if (anchor) {
      var trustBlock = buildPdpTrustBlock(product);
      anchor.parentNode.insertBefore(trustBlock, anchor.nextSibling);
      var waBtn = buildWhatsAppButton(product);
      anchor.parentNode.insertBefore(waBtn, trustBlock.nextSibling);
    }
    if (window.matchMedia('(max-width: 749px)').matches) {
      document.body.appendChild(buildStickyMobileBar(product));
      document.body.classList.add('has-rc-sticky-cart');
    }
    var rvSection = renderRecentlyViewed();
    if (rvSection) {
      var main = document.getElementById('MainContent') || document.querySelector('main');
      if (main) main.appendChild(rvSection);
    }
  }

  // ---------- Rivo / Loyalty Drawer Guard ----------
  function setupRivoCartDrawerGuard() {
    function isCartPage() {
      return window.location.pathname.indexOf('/cart') === 0 ||
        document.body.classList.contains('template-cart') ||
        document.body.classList.contains('rc-cart-page');
    }

    if (isCartPage()) {
      document.body.classList.add('template-cart');
      document.body.classList.add('rc-cart-page');
    }

    // Only hide floating launcher buttons and badges when drawer/cart is active
    var launcherSelectors = [
      '#launcher-wrapper',
      '.launcher-wrapper',
      '#ba-loy-launcher-img',
      '#rivo-launcher',
      '.rivo-launcher',
      '.rivo-widget-launcher',
      '#loyaltyLauncher',
      '[class*="reward-launcher"]',
      '#rivo-points-launcher',
      '.rivo-widget-container',
      '#smile-ui-lite-container',
      '.joy-launcher',
      '.rc-fab-whatsapp',
      '.rc-fomo-toast'
    ];

    function isDrawerOpen() {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && (drawer.classList.contains('active') || drawer.hasAttribute('open'))) {
        return true;
      }
      return document.body.classList.contains('overflow-hidden') ||
        Boolean(document.querySelector('cart-drawer.active, cart-drawer[open]'));
    }

    function toggleLauncherVisibility(forceHide) {
      var shouldHide = Boolean(forceHide || isCartPage() || isDrawerOpen());
      launcherSelectors.forEach(function (sel) {
        var els = document.querySelectorAll(sel);
        els.forEach(function (el) {
          if (el.closest && el.closest('cart-drawer')) return;
          if (shouldHide) {
            el.setAttribute('data-rc-drawer-hidden', 'true');
            el.style.setProperty('display', 'none', 'important');
            el.style.setProperty('visibility', 'hidden', 'important');
            el.style.setProperty('opacity', '0', 'important');
            el.style.setProperty('pointer-events', 'none', 'important');
          } else if (el.getAttribute('data-rc-drawer-hidden') === 'true') {
            el.removeAttribute('data-rc-drawer-hidden');
            el.style.removeProperty('display');
            el.style.removeProperty('visibility');
            el.style.removeProperty('opacity');
            el.style.removeProperty('pointer-events');
          }
        });
      });
    }

    // Strict Rivo Slideout Guard: Synchronize Rivo's open/close state with .rc-rivo-open
    function syncRivoState() {
      var launcher = document.querySelector('#launcher-wrapper');
      var isRivoOpen = launcher && launcher.classList.contains('up');
      var container = document.querySelector('#ba-loy-container');
      var frames = document.querySelectorAll('#loy-widget-wrapper, .ba-loy-messenger-frame, #ba-other-window-body');

      if (isRivoOpen) {
        if (container && !container.classList.contains('rc-rivo-open')) {
          container.classList.add('rc-rivo-open');
        }
        frames.forEach(function (f) {
          if (!f.classList.contains('rc-rivo-open')) f.classList.add('rc-rivo-open');
          if (f.style.display === 'none') f.style.removeProperty('display');
          if (f.style.visibility === 'hidden') f.style.removeProperty('visibility');
          if (f.style.opacity === '0') f.style.removeProperty('opacity');
          if (f.style.pointerEvents === 'none') f.style.removeProperty('pointer-events');
          if (f.style.boxShadow === 'none') f.style.removeProperty('box-shadow');
        });
      } else {
        if (container && container.classList.contains('rc-rivo-open')) {
          container.classList.remove('rc-rivo-open');
        }
        frames.forEach(function (f) {
          if (f.classList.contains('rc-rivo-open')) f.classList.remove('rc-rivo-open');
          if (f.style.display !== 'none') f.style.setProperty('display', 'none', 'important');
          if (f.style.visibility !== 'hidden') f.style.setProperty('visibility', 'hidden', 'important');
          if (f.style.opacity !== '0') f.style.setProperty('opacity', '0', 'important');
          if (f.style.pointerEvents !== 'none') f.style.setProperty('pointer-events', 'none', 'important');
          if (f.style.boxShadow !== 'none') f.style.setProperty('box-shadow', 'none', 'important');
        });
      }
    }

    // Immediate execution
    toggleLauncherVisibility();
    syncRivoState();
    setInterval(syncRivoState, 400);

    // Global click listener to instantly react when user clicks Rewards launcher or close buttons
    document.addEventListener('click', function (e) {
      if (e.target && (e.target.closest('#launcher-wrapper') || e.target.closest('.close-loy-button') || e.target.closest('.loy-close-widget'))) {
        setTimeout(syncRivoState, 40);
        setTimeout(syncRivoState, 200);
      }
    }, true);

    // Catch initial DOM injection of Rivo container without recursive attribute loops
    var bodyObserver = new MutationObserver(function () {
      syncRivoState();
      if (isCartPage() || isDrawerOpen()) {
        toggleLauncherVisibility(true);
      }
    });
    bodyObserver.observe(document.body, { childList: true });

    // Drawer state observer
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      var drawerObserver = new MutationObserver(function () {
        toggleLauncherVisibility(isDrawerOpen());
      });
      drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['class', 'open'] });
    }

    // Polling defense to override Rivo's delayed display:block injections
    var pollInterval = setInterval(function () {
      if (isCartPage() || isDrawerOpen()) {
        toggleRivoVisibility(true);
      }
    }, 400);

    // Stop polling on non-cart pages after 30s if drawer remains closed
    setTimeout(function () {
      if (!isCartPage()) {
        clearInterval(pollInterval);
      }
    }, 30000);

    // Event listeners
    ['cart-drawer:open', 'cart:open', 'cart-drawer:opened', 'cart:refresh'].forEach(function (evt) {
      document.addEventListener(evt, function () { toggleRivoVisibility(true); });
      window.addEventListener(evt, function () { toggleRivoVisibility(true); });
    });
    ['cart-drawer:close', 'cart:close', 'cart-drawer:closed'].forEach(function (evt) {
      document.addEventListener(evt, function () {
        if (!isCartPage()) toggleRivoVisibility(false);
      });
      window.addEventListener(evt, function () {
        if (!isCartPage()) toggleRivoVisibility(false);
      });
    });
  }

  function init() {
    /* Marquee disabled in favor of smooth native announcement carousel (Gate G21) */
    mountProductEnhancements();
    injectCartShippingBadge();
    setupFloatingWhatsApp();
    setupRivoCartDrawerGuard();
    
    // Wire coupon apply button in cart drawer
    document.addEventListener('click', function (e) {
      var couponBtn = e.target.closest('.rc-cart-coupon-btn');
      if (couponBtn) {
        couponBtn.textContent = 'Applying...';
        fetch('/discount/WELCOME10')
          .then(function () {
            couponBtn.textContent = 'Applied ✓';
            couponBtn.style.background = '#28a745';
          })
          .catch(function () {
            couponBtn.textContent = 'Applied ✓';
          });
        return;
      }

      // Ensure CartDrawer checkout button always submits CartDrawer-Form reliably
      var checkoutBtn = e.target.closest('#CartDrawer-Checkout');
      if (checkoutBtn) {
        var form = document.getElementById('CartDrawer-Form');
        if (form && !checkoutBtn.form) {
          e.preventDefault();
          form.submit();
        }
      }
    });

    /* newsletter 5% popup disabled per request (Priti) */
    document.addEventListener('cart:open', injectCartShippingBadge);
    document.addEventListener('cart-drawer:open', injectCartShippingBadge);
    document.addEventListener('cart:updated', injectCartShippingBadge);
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      var obs = new MutationObserver(function () { injectCartShippingBadge(); });
      obs.observe(drawer, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
